module.exports = __webpack_public_path__ + "media/images/icons/outlined/italic-e8a0d45ade8419eb1c195012cf4a3134.svg";